import React from "react";
import { Drawer } from "antd";
import { CloseOutlined, ArrowLeftOutlined } from "@ant-design/icons";

const CommonDrawer = ({ children, open, onClose, className = "", onBack, width=444 }) => {
  // useEffect(() => {
  //   if (open) {
  //     setTimeout(() => {
  //       const drawerBody = document.querySelector(".ant-drawer-body");
  //       if (drawerBody) {
  //         drawerBody.scrollTop = 0; // Scroll to top
  //       }
  //     }, 100); // Small delay to ensure the drawer is fully rendered
  //   }
  // }, [open]);

  return (
    <Drawer
      title=""
      closeIcon={<CloseOutlined className="custom-close-icon" />}
      width={width}
      onClose={onClose}
      open={open}
      className={`common-drawer ${className}`}
      bodyStyle={{ overflowY: "auto" }} // Ensures proper scrolling
    >
      {onBack && (
        <div style={{ position: "absolute", top: "20px" }}>
          <ArrowLeftOutlined
            onClick={onBack}
            style={{
              fontSize: "14px",
              cursor: "pointer",
            }}
          />
        </div>
      )}
      {children}
    </Drawer>
  );
};

export default CommonDrawer;
